import React, { useEffect, useRef } from 'react';
import { useGoogleMaps } from './GoogleMapsProvider';

const AddressAutocomplete = ({ value, onChange, onPlaceSelected }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const { isLoaded } = useGoogleMaps();

  useEffect(() => {
    if (isLoaded && inputRef.current && !autocompleteRef.current) {
      // Initialize Google Places Autocomplete
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          componentRestrictions: { country: 'ca' }, // Restrict to Canada
          fields: ['formatted_address', 'address_components', 'geometry'],
          types: ['address']
        }
      );

      // Listen for place selection
      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        
        if (place && place.formatted_address) {
          // Call the callback with the selected place (including coordinates)
          if (onPlaceSelected) {
            onPlaceSelected(place);
          }
          
          // Update the input value
          if (onChange) {
            onChange({
              target: {
                name: 'adresse',
                value: place.formatted_address
              }
            });
          }
        }
      });
    }
  }, [isLoaded, onChange, onPlaceSelected]);

  if (!isLoaded) {
    return (
      <input
        type="text"
        name="adresse"
        value={value}
        onChange={onChange}
        placeholder="123 Rue Principale, Bromont, QC J2L 1A1"
        required
        className="form-input-new"
      />
    );
  }

  return (
    <input
      ref={inputRef}
      type="text"
      name="adresse"
      value={value}
      onChange={onChange}
      placeholder="123 Rue Principale, Bromont, QC J2L 1A1"
      required
      className="form-input-new"
      autoComplete="off"
    />
  );
};

export default AddressAutocomplete;
